<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-4 pt-lg-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">
                Use this form to login to your account
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-header bg-transparent pb-5"></div>
            <div class="card-body px-lg-5 py-lg-2">
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="EmailOrPhone"
                    :rules="{ required: true }"
                    prepend-icon="ni email-1"
                    placeholder="Email or Phone number"
                    v-model="model.email"
                  ></base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    :rules="{ required: true, min: 4 }"
                    prepend-icon="ni ic_lock_open"
                    type="password"
                    placeholder="Password"
                    v-model="model.password"
                  ></base-input>

                  <base-checkbox v-model="model.rememberMe"
                    >Remember me</base-checkbox
                  >
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4"
                      >Sign in</base-button
                    >
                    <h5 style="color: red" v-if="model.notfound">
                      User doesn't exist or password is incorrect
                    </h5>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/reset" class="text-light">
                <small>Forgot password?</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Encrypt,
  GenerateToken,
  GeneratePwd,
  EncryptAES,
} from "../../services/crypto";
import { Auth, UserIdByEmail } from "../../services/user";
import { SetUser, SetCookie, LoadCookie } from "../../services/localstate";
import { rebind } from "d3";
export default {
  data() {
    return {
      model: {
        email: "h.salamov@gmail.com",
        password: "1111",
        rememberMe: false,
        notfound: false,
      },
    };
  },
  methods: {
    onSubmit() {
      this.model.notfound = false;

      UserIdByEmail(this.model).then((r1) => {
        if (r1.data.result.id !== null) {
          const pwd = Encrypt(this.model.password, r1.data.result.pwdtoken);
          Auth(this.model.email, pwd.key).then((response) => {
            if (response.data.result) {
              this.proceedUser(response.data.result);
            } else this.model.notfound = true;
          });
        } else this.model.notfound = true;
      });
    },

    proceedUser(user) {
      SetCookie("gtoken", GenerateToken());
      SetUser(user);
      SetCookie("rememberme", this.model.rememberMe);
      if (user.roleid === 1)
        this.$router.push({ path: "/manager" }).catch((e) => {});
      if (user.roleid === 3)
        this.$router.push({ path: "/student" }).catch((e) => {});
    },
  },
  mounted() {
    let value = LoadCookie("rememberme");
    if (value) {
      const autoredirect = value === "true";
      this.model.rememberMe = autoredirect;
      if (autoredirect) {
        if (this.$store.state.user) {
          UserIdByEmail(this.$store.state.user).then((response) => {
            if (response) this.proceedUser(this.$store.state.user);
          });
          // if (this.$store.state.user.roleid === "1")
          //   this.$router.push({ path: "/manager" }).catch((e) => {});
        }
      }
    }
  },
};
</script>
